import React, { useRef, useState } from "react";
import style from "./index.module.scss";
import { RouteComponentProps, useHistory } from "react-router-dom";
import TopicDetail from "./components/TopicDetail";
import { useFullscreen, useToggle } from "react-use";
import FloatBtn from "./components/FloatBtn";
import classNames from "classnames";
import TopicList from "./components/TopicList";
import { useAtomValue } from "jotai";
import PageSpin from "../components/PageSpin";
import LoadingBoundary from "components/LoadingBoundary";
import { Provider } from "jotai";
import { errorMessage } from "service/service";
import {
    exerciseIdAtom,
    selectedIndexAtom,
    selectedQuestion
} from "service/stores/Exercise/Statics";

interface ExerciseProps {
    exerciseId: string;
}

function Exercise() {
    const history = useHistory();
    const ref = useRef<HTMLDivElement>(null);
    const [isFullscreen, toggleFullScreen] = useToggle(false);
    useFullscreen(ref, isFullscreen, {
        onClose: () => toggleFullScreen(false)
    });

    const selectedIndex = useAtomValue(selectedIndexAtom);
    const question = useAtomValue(selectedQuestion(selectedIndex));

    const [showList, setShowList] = useState(false);

    return (
        <div className={classNames(style.root, "ExerciseContainer")} ref={ref}>
            {showList && <TopicList setShowList={setShowList} />}
            {!showList && <TopicDetail index={selectedIndex} data={question} />}

            <div
                className={style.close}
                role="button"
                onClick={history.goBack}
            />

            <FloatBtn
                isFullscreen={isFullscreen}
                toggleFullScreen={toggleFullScreen}
                showList={showList}
                setShowList={setShowList}
            />
        </div>
    );
}

export default function ExerciseRoot({
    match
}: RouteComponentProps<ExerciseProps>) {
    const exerciseId = match.params.exerciseId;

    function errorFallback(e: any) {
        return <div>{errorMessage(e)}</div>;
    }

    return (
        <LoadingBoundary fallback={<PageSpin />} errorFallback={errorFallback}>
            <Provider initialValues={[[exerciseIdAtom, exerciseId]] as any}>
                <Exercise />
            </Provider>
        </LoadingBoundary>
    );
}
